import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStatusMarkIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M28 44.292L36.731 44.292",
		stroke: "{props.stroke}",
		strokeWidth: 12.1062,
		strokeLinecap: "round"
	})
});
export default SvgStatusMarkIcon;
